module.exports = __webpack_public_path__ + "static/img/9.3b4c8f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/zh/9.png
// module id = ILyl
// module chunks = 0